export const coursesData = [
  { label: "Batak Toba", active: true },
  { label: "Batak Karo", active: false },
  { label: "Batak Angkola-Mandailing", active: false },
  { label: "Batak Pakpak", active: false },
  { label: "Batak Simalungun", active: false },
];
